let routes = [
	{
		// 登录
		path: '/HelloWorld',
		name: 'HelloWorld',
		component: () => import('@/components/HelloWorld'),
		meta: {
			title: '首页',
			keepAlive: true
		}
	},

];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routerPage/index.js